/* Deadstock MKE - theme interactions
   Drawer open/close + wishlist (localStorage 'ds_saved').
   Product-page interactions (gallery, size chips, accordions, read-more)
   live in templates/product.liquid - do NOT rebind them here, double-bound
   handlers cancel each other (accordions opened+closed in one tap).
   Vanilla JS, no deps. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Wishlist store (localStorage 'ds_saved') ----------
     ds_saved = JSON array of {handle,title,image,price,url,t},
     newest-first, deduped by handle, capped at 50. */
  var DS_SAVED_KEY = 'ds_saved';
  var DS_SAVED_CAP = 50;

  function lsAvailable() {
    try {
      var k = '__ds_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }

  function readSaved() {
    if (!lsAvailable()) return [];
    try {
      var raw = window.localStorage.getItem(DS_SAVED_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeSaved(arr) {
    if (!lsAvailable()) return;
    try {
      window.localStorage.setItem(DS_SAVED_KEY, JSON.stringify(arr.slice(0, DS_SAVED_CAP)));
    } catch (e) { /* quota / unavailable: no-op */ }
  }

  function updateSavedCount(n) {
    document.querySelectorAll('[data-saved-count]').forEach(function (el) {
      el.textContent = String(n);
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function reflectSavedState(handle, on) {
    document.querySelectorAll('[data-ds-save][data-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]').forEach(function (b) {
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function toggleSaved(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var arr = readSaved();
    var idx = -1;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] && arr[i].handle === handle) { idx = i; break; }
    }
    var nowSaved;
    if (idx > -1) {
      arr.splice(idx, 1);
      nowSaved = false;
    } else {
      arr.unshift({
        handle: handle,
        title: btn.getAttribute('data-title') || '',
        image: btn.getAttribute('data-image') || '',
        price: btn.getAttribute('data-price') || '',
        url: btn.getAttribute('data-url') || '',
        t: Date.now()
      });
      nowSaved = true;
    }
    writeSaved(arr);
    reflectSavedState(handle, nowSaved);
    updateSavedCount(Math.min(arr.length, DS_SAVED_CAP));
  }

  /* ONE delegated capture-phase listener owns every save button on the page. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-ds-save]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleSaved(btn);
  }, true);

  ready(function () {
    /* The mobile drawer (and its brands sub-menu) lives in sections/header.liquid, which owns its own data-hdr-* markup and script. */

    /* ---------- Wishlist hydrate (localStorage 'ds_saved') ---------- */
    (function hydrateWishlist() {
      var saved = readSaved();
      var handles = {};
      saved.forEach(function (item) { if (item && item.handle) handles[item.handle] = true; });
      document.querySelectorAll('[data-ds-save]').forEach(function (btn) {
        var h = btn.getAttribute('data-handle');
        var on = !!(h && handles[h]);
        btn.classList.toggle('is-saved', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      updateSavedCount(saved.length);
    })();

    /* watchdog: if the page is scroll-locked but nothing is actually open
       (drawer, filter sheet, quick view, lightbox, Klaviyo form), release the
       lock - a stuck lock is what makes the site "freeze until refresh" */
    /* Klaviyo closes its pop-up by fading an OUTER layer to opacity 0 and sometimes leaves it
       mounted with the body lock on (desktop "site froze, wheel does nothing", 2026-11-03).
       So "can the shopper see it" must check every ancestor, not just the form box itself. */
    function seenOnScreen(el){
      for(var e = el; e && e !== document.body; e = e.parentElement){
        var c = window.getComputedStyle(e);
        if(c.display === 'none' || c.visibility === 'hidden' || parseFloat(c.opacity || '1') < 0.05) return false;
      }
      return true;
    }

    setInterval(function(){
      var b = document.body;
      var locked = (b.style.overflow === 'hidden') || (document.documentElement.style.overflow === 'hidden') || b.classList.contains('klaviyo-prevent-body-scrolling') || b.classList.contains('ds-qv-lock') || b.classList.contains('ds-noscroll');
      if(!locked) return;
      if(document.querySelector('[data-ds-drawer].is-open, .ds-drawer.is-open, [data-hdr-drawer].is-open, .dsc-sheet.is-open, .ds-qv.is-open, [data-qv-overlay].is-open, [data-ds-lightbox]:not([hidden]), [data-ds-sizefinder]:not([hidden]), [data-ds-offer]:not([hidden])')) return;
      var kl = document.querySelectorAll('[class*="klaviyo-form"]');
      for(var i = 0; i < kl.length; i++){
        var r = kl[i].getBoundingClientRect();
        if(r.width > 150 && r.height > 150){
          var cs = window.getComputedStyle(kl[i]);
          /* only a form the shopper can actually SEE - visible AND on screen - 
             justifies keeping the page locked (iOS Chrome sometimes keeps the
             lock while the card never paints or sits off-viewport) */
          var onScreen = r.right > 20 && r.bottom > 20 && r.left < window.innerWidth - 20 && r.top < window.innerHeight - 20;
          if(onScreen && kl[i].offsetParent !== null && seenOnScreen(kl[i])) return;
        }
      }
      b.style.overflow = '';
      document.documentElement.style.overflow = '';
      b.classList.remove('klaviyo-prevent-body-scrolling');
      b.classList.remove('ds-qv-lock');
      b.classList.remove('ds-noscroll');
    }, 2000);

    /* a full-screen overlay that is INVISIBLE but still catching touches makes
       the page feel frozen with no scroll-lock involved - neutralize those */
    setInterval(function(){
      var els = document.querySelectorAll('[class*="kl-"], [class*="klaviyo"], [id*="klaviyo"], [class*="needsclick"]');
      for(var i = 0; i < els.length; i++){
        var el = els[i];
        var cs = window.getComputedStyle(el);
        if(cs.position !== 'fixed') continue;
        if(cs.pointerEvents === 'none') continue;
        var r = el.getBoundingClientRect();
        if(r.width < window.innerWidth * 0.85 || r.height < window.innerHeight * 0.85) continue;
        if(parseFloat(cs.opacity || '1') < 0.05 || cs.visibility === 'hidden' || !seenOnScreen(el)){
          el.style.pointerEvents = 'none';
          continue;
        }
        /* wrapper is full-screen and claims to be visible - but if the form card
           inside it never painted, is hidden, or sits off-viewport, the wrapper is
           an invisible touch trap (the iOS Chrome "site locked up" bug). A tap-
           catching layer is only allowed while a real card is on screen. */
        var card = el.querySelector('form');
        var cardOk = false;
        if(card){
          var cr = card.getBoundingClientRect();
          var ccs = window.getComputedStyle(card);
          cardOk = cr.width > 100 && cr.height > 80 &&
                   cr.right > 20 && cr.bottom > 20 &&
                   cr.left < window.innerWidth - 20 && cr.top < window.innerHeight - 20 &&
                   ccs.visibility !== 'hidden' && seenOnScreen(card);
        }
        if(!cardOk){ el.style.pointerEvents = 'none'; }
      }
    }, 2000);
  });
})();


/* ============================================================
   Quick Look modal - moved out of snippets/quick-view.liquid
   (was ~10KB inlined into EVERY page, cacheable now)
   ============================================================ */
(function(){
  if (window.__dsQuickViewInit) return;
  window.__dsQuickViewInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  var overlay = document.querySelector('[data-qv-overlay]');
  if (!overlay) return;

  var card      = overlay.querySelector('[data-qv-card]');
  var loadingEl = overlay.querySelector('[data-qv-loading]');
  var bodyEl    = overlay.querySelector('[data-qv-body]');
  var errorEl   = overlay.querySelector('[data-qv-error]');

  var imgEl     = overlay.querySelector('[data-qv-img]');
  var noImgEl   = overlay.querySelector('[data-qv-noimg]');
  var vendorEl  = overlay.querySelector('[data-qv-vendor]');
  var titleEl   = overlay.querySelector('[data-qv-title]');
  var priceEl   = overlay.querySelector('[data-qv-price]');
  var sizesEl   = overlay.querySelector('[data-qv-sizes]');
  var sizesLbl  = overlay.querySelector('[data-qv-sizes-label]');
  var chipsEl   = overlay.querySelector('[data-qv-chips]');
  var atcEl     = overlay.querySelector('[data-qv-atc]');
  var nudgeEl   = overlay.querySelector('[data-qv-nudge]');
  var detailsEl = overlay.querySelector('[data-qv-details]');
  var errLink   = overlay.querySelector('[data-qv-error-link]');

  var lastFocus = null;
  var reqToken = 0;
  var state = { variantId: null, hasSizes: false, addedTimer: null };

  /* ---- translatable strings ----------------------------------------------
     Every word the shopper can see comes from a data-* attribute on the
     [data-qv-overlay] element (snippets/quick-view.liquid), so it can be run
     through the locale files later. The English here is only the fallback for
     when the attribute has not been added yet. Attributes read:
       data-qv-t-add · data-qv-t-adding · data-qv-t-added · data-qv-t-select-size
       data-qv-t-unavailable · data-qv-t-add-error · data-qv-t-size · data-qv-t-from
     ------------------------------------------------------------------------ */
  function t(name, fallback){
    var v = overlay.getAttribute('data-qv-t-' + name);
    if (v === null) return fallback;
    v = v.replace(/^\s+|\s+$/g, '');
    if (v === '') return fallback;
    return v;
  }
  function addLabel(){ return t('add', 'Add to Bag'); }

  function money(cents){
    var n = (cents || 0) / 100;
    var s = n.toFixed(2);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function setView(view){ // 'loading' | 'body' | 'error'
    loadingEl.style.display = (view === 'loading') ? 'flex' : 'none';
    bodyEl.hidden  = (view !== 'body');
    errorEl.hidden = (view !== 'error');
  }

  /* ---- focus containment -------------------------------------------------
     The dialog is modal, so Tab must not walk out behind the backdrop. */
  var trapRoot = card || overlay;
  if (trapRoot && !trapRoot.hasAttribute('tabindex')) trapRoot.setAttribute('tabindex', '-1');

  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function focusables(){
    var list = trapRoot.querySelectorAll(FOCUSABLE);
    var out = [];
    for (var i = 0; i < list.length; i++){
      var el = list[i];
      if (el.disabled) continue;
      if (el.getAttribute('tabindex') === '-1') continue;
      if (el.getAttribute('aria-hidden') === 'true') continue;
      if (!el.getClientRects().length) continue; // hidden view (loading/error/body)
      out.push(el);
    }
    return out;
  }

  function focusTarget(){
    var items = focusables();
    return items.length ? items[0] : trapRoot;
  }

  function trapTab(e){
    var items = focusables();
    if (!items.length){
      e.preventDefault();
      if (trapRoot.focus){ try{ trapRoot.focus(); }catch(err){} }
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!active || !trapRoot.contains(active)){
      e.preventDefault();
      if (e.shiftKey) last.focus(); else first.focus();
      return;
    }
    if (e.shiftKey && active === first){
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last){
      e.preventDefault();
      first.focus();
    }
  }

  function lockScroll(){ document.body.classList.add('ds-qv-lock'); }
  function unlockScroll(){ document.body.classList.remove('ds-qv-lock'); }

  function openOverlay(){
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    lockScroll();
  }

  function closeOverlay(){
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    unlockScroll();
    reqToken++; // invalidate any in-flight populate
    if (state.addedTimer){ clearTimeout(state.addedTimer); state.addedTimer = null; }
    if (lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} }
    lastFocus = null;
  }

  function resetUI(handle){
    state.variantId = null;
    state.hasSizes = false;
    nudgeEl.hidden = true; nudgeEl.textContent = '';
    chipsEl.innerHTML = '';
    sizesEl.hidden = true;
    imgEl.src = ''; imgEl.alt = ''; imgEl.style.display = '';
    noImgEl.hidden = true;
    vendorEl.textContent = '';
    titleEl.textContent = '';
    priceEl.textContent = '';
    atcEl.disabled = false;
    atcEl.classList.remove('is-added');
    atcEl.textContent = addLabel();
    var url = '/products/' + handle;
    detailsEl.setAttribute('href', url);
    if (errLink) errLink.setAttribute('href', url);
  }

  function renderPriceFrom(price, compareAt, varies){
    var label = money(price);
    if (varies){
      label = t('from', 'From {{ price }}').replace(/\{\{\s*price\s*\}\}/g, label);
    }
    priceEl.textContent = '';
    if (compareAt && compareAt > price){
      var sale = document.createElement('span');
      sale.className = 'ds-qv__sale';
      sale.textContent = label;
      var was = document.createElement('span');
      was.className = 'ds-qv__was';
      was.textContent = money(compareAt);
      priceEl.appendChild(sale);
      priceEl.appendChild(was);
    } else {
      priceEl.textContent = label;
    }
  }

  /* Headline price, shown while NO size is selected.
     Sale prices on this store are set PER SIZE, so product.price_min and
     product.compare_at_price_max come from DIFFERENT sizes and may both belong
     to sizes that are sold out - that advertises a price nobody can buy. Same
     rule as snippets/product-card.liquid and templates/product.liquid: walk the
     sizes a shopper can ACTUALLY buy, take the cheapest of those, carry THAT
     size's own was-price, and say "From" only when the buyable sizes differ.
     If nothing is buyable the product is sold out anyway, so fall back to the
     full variant list (again matching the card). */
  function headlinePrice(p){
    var variants = p.variants || [];
    var found = false, low = 0, top = 0, cmp = 0;
    function consider(v){
      var c = v.compare_at_price;
      if (c === null || c === undefined) c = 0;
      if (!found){ found = true; low = v.price; top = v.price; cmp = c; return; }
      if (v.price < low){ low = v.price; cmp = c; }
      if (v.price > top){ top = v.price; }
    }
    var i;
    for (i = 0; i < variants.length; i++){ if (variants[i].available) consider(variants[i]); }
    if (!found){ for (i = 0; i < variants.length; i++){ consider(variants[i]); } }
    if (!found) return { price: p.price || 0, compareAt: 0, varies: false };
    return { price: low, compareAt: cmp, varies: top > low };
  }

  function renderPrice(p){
    var h = headlinePrice(p);
    renderPriceFrom(h.price, h.compareAt, h.varies);
  }

  /* this size's own price + its own was-price, or no sale wording at all if
     this size is not reduced (sale prices here are set PER SIZE) */
  function renderVariantPrice(v){
    if (!v) return;
    renderPriceFrom(v.price, v.compare_at_price || 0);
  }

  function firstAvailableVariant(p){
    for (var i = 0; i < p.variants.length; i++){
      if (p.variants[i].available) return p.variants[i];
    }
    return p.variants[0];
  }

  function setActiveChip(btn){
    var all = chipsEl.querySelectorAll('.ds-qv__chip');
    for (var i = 0; i < all.length; i++){
      all[i].classList.remove('is-active');
      all[i].setAttribute('aria-pressed', 'false');
    }
    if (btn){
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    }
    nudgeEl.hidden = true;
    nudgeEl.textContent = '';
  }

  function selectVariant(v, btn){
    state.variantId = v.id;
    setActiveChip(btn);
    renderVariantPrice(v);
  }

  /* "OS" (one size) is a pseudo-size - there is nothing for the shopper to
     choose, so it may be selected for them. Matches the product page. */
  function isOneSize(label){
    return String(label || '').toUpperCase().replace(/[^A-Z]/g, '') === 'OS';
  }

  function buildSizes(p){
    // Find the option whose name includes "size".
    var optIndex = -1;
    (p.options || []).forEach(function(opt, i){
      // AJAX .js endpoint returns option OBJECTS ({name,position,values}); older
      // code assumed strings, so "Shoe size" was never found and chips never built
      var nm = typeof opt === 'string' ? opt : (opt && opt.name) || '';
      if (optIndex === -1 && nm.toLowerCase().indexOf('size') !== -1) optIndex = i;
    });

    if (optIndex === -1 || p.variants.length <= 1){
      // No size option / single variant: skip chips, default variant.
      state.hasSizes = false;
      var v = firstAvailableVariant(p);
      state.variantId = v ? v.id : null;
      // nothing for the shopper to pick, so the price shown must be the one
      // actually being added rather than a "From" headline
      if (v) renderVariantPrice(v);
      return;
    }

    state.hasSizes = true;
    // same object-vs-string shape as above: an option OBJECT put straight into
    // textContent prints the literal words "[object Object]" as the size label
    var optName = p.options[optIndex];
    if (optName && typeof optName !== 'string') optName = optName.name;
    sizesLbl.textContent = optName || t('size', 'Size');

    // One chip per variant (variants carry option1/2/3).
    var optKey = 'option' + (optIndex + 1);

    /* NO preselected size - the buyer must tap one, so the price shown always
       matches the variant that gets added and nobody is sold the wrong size on
       one-of-one stock. Same rule as templates/product.liquid. */
    state.variantId = null;
    var pickable = [];

    p.variants.forEach(function(v){
      /* Sold-out sizes are hidden entirely, never struck through - the same
         standing rule templates/product.liquid follows for the size grid. */
      if (!v.available) return;
      var label = v[optKey] || v.title;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ds-qv__chip';
      btn.textContent = label;
      btn.setAttribute('data-variant-id', v.id);
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function(){ selectVariant(v, btn); });
      pickable.push({ variant: v, button: btn, label: label });
      chipsEl.appendChild(btn);
    });

    // Everything sold out: there is no size to choose, so hide the empty size
    // block and let the button say "unavailable" rather than nag for a size.
    if (pickable.length === 0){
      state.hasSizes = false;
      sizesEl.hidden = true;
      return;
    }

    sizesEl.hidden = false;

    // One-size-only stock: nothing to choose, so choose it for them.
    var onlyOS = pickable.length > 0;
    for (var i = 0; i < pickable.length; i++){
      if (!isOneSize(pickable[i].label)){ onlyOS = false; break; }
    }
    if (onlyOS){
      state.hasSizes = false;
      selectVariant(pickable[0].variant, pickable[0].button);
    }
  }

  function populate(p, handle){
    // Image
    var src = p.featured_image || (p.images && p.images[0]) || '';
    if (src){
      // .js gives protocol-relative or absolute URLs; request a sane size.
      var url = src;
      if (url.indexOf('//') === 0) url = 'https:' + url;
      imgEl.src = url;
      imgEl.alt = p.title || '';
      imgEl.style.display = '';
      noImgEl.hidden = true;
    } else {
      imgEl.removeAttribute('src');
      imgEl.style.display = 'none';
      var nt = noImgEl.querySelector('[data-qv-noimg-title]');
      if(nt){ nt.textContent = p.title || ''; }
      noImgEl.hidden = false;
    }

    vendorEl.textContent = p.vendor || '';
    vendorEl.style.display = p.vendor ? '' : 'none';
    titleEl.textContent = p.title || '';
    renderPrice(p);
    buildSizes(p);

    detailsEl.setAttribute('href', '/products/' + (p.handle || handle));
    setView('body');
  }

  function bumpCartCount(addedQty){
    var el = document.querySelector('[data-cart-count]');
    if (el){
      var n = parseInt(el.textContent, 10);
      if (isNaN(n)) n = 0;
      n += addedQty;
      el.textContent = n;
      el.style.display = 'flex';
      return true;
    }
    // No known count element. Try to update from cart.js, else reload.
    return false;
  }

  function refreshCartCount(){
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var el = document.querySelector('[data-cart-count]');
        if (el){
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(function(){});
  }

  function addToCart(){
    if (atcEl.disabled) return;

    if (state.hasSizes && !state.variantId){
      nudgeEl.textContent = t('select-size', 'Select a size');
      nudgeEl.hidden = false;
      var firstChip = chipsEl.querySelector('.ds-qv__chip:not([disabled])');
      if (firstChip && firstChip.focus){ try{ firstChip.focus(); }catch(e){} }
      return;
    }
    if (!state.variantId){
      nudgeEl.textContent = t('unavailable', 'This item is unavailable');
      nudgeEl.hidden = false;
      return;
    }

    atcEl.disabled = true;
    var prevTxt = addLabel();
    atcEl.textContent = t('adding', 'Adding…');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: state.variantId, quantity: 1 })
    })
    .then(function(res){
      if (!res.ok) return res.json().then(function(j){ throw j; });
      return res.json();
    })
    .then(function(){
      if (!bumpCartCount(1)) refreshCartCount();
      atcEl.classList.add('is-added');
      atcEl.textContent = t('added', 'Added ✓');
      if (state.addedTimer) clearTimeout(state.addedTimer);
      state.addedTimer = setTimeout(function(){
        atcEl.classList.remove('is-added');
        atcEl.textContent = prevTxt;
        atcEl.disabled = false;
      }, 1600);
    })
    .catch(function(err){
      atcEl.disabled = false;
      atcEl.textContent = prevTxt;
      nudgeEl.textContent = (err && err.description) ? err.description : t('add-error', 'Couldn’t add to bag · try again');
      nudgeEl.hidden = false;
    });
  }

  function fetchProduct(handle){
    var token = ++reqToken;
    var primary = root + 'products/' + handle + '.js';
    var fallback = '/products/' + handle + '.js';

    function tryFetch(u){
      return fetch(u, { headers: { 'Accept': 'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('bad'); return r.json(); });
    }

    tryFetch(primary)
      .catch(function(){ return tryFetch(fallback); })
      .then(function(p){
        if (token !== reqToken) return; // closed or superseded
        populate(p, handle);
      })
      .catch(function(){
        if (token !== reqToken) return;
        setView('error');
      });
  }

  function openFor(handle, trigger){
    lastFocus = trigger || null;
    resetUI(handle);
    setView('loading');
    openOverlay();
    fetchProduct(handle);
    /* Move focus INTO the dialog. NB the backdrop also carries [data-qv-close]
       and comes first in the DOM, so a bare [data-qv-close] lookup returned a
       plain <div> that cannot take focus - ask for the button. */
    var x = overlay.querySelector('button[data-qv-close]') || focusTarget();
    if (x && x.focus){ try{ x.focus(); }catch(e){} }
  }

  // ---- Event delegation (CAPTURE phase) ----
  // Run on capture so we fire before the surrounding product-card <a> navigates
  // AND before any descendant handler can stopPropagation (which previously
  // swallowed the click and stopped the modal from opening). preventDefault here
  // cancels the card-link navigation; if this script never loads, the button
  // simply falls back to opening the product page. Graceful degradation.
  document.addEventListener('click', function(e){
    var trigger = e.target.closest && e.target.closest('[data-quick-handle]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = trigger.getAttribute('data-quick-handle');
    if (handle) openFor(handle, trigger);
  }, true);

  overlay.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('[data-qv-close]')) closeOverlay();
  });

  atcEl.addEventListener('click', addToCart);

  document.addEventListener('keydown', function(e){
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape'){ closeOverlay(); return; }
    if (e.key === 'Tab' || e.keyCode === 9) trapTab(e);
  });
})();
